/**
 * Standalone Validators
 * Pure validation functions that can be used independently.
 * Shared between backend and frontend.
 */
// ============================================================================
// Regex Patterns
// ============================================================================
/** RFC-compliant email regex */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const EMAIL_MAX_LENGTH = 254; // RFC 5321
/** Basic URL pattern - http(s) with domain */
export const URL_REGEX = /^https?:\/\/[^\s/$.?#].[^\s]*$/i;
/** Ethereum address format: 0x followed by 40 hexadecimal characters */
export const WALLET_ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/;
/** UUID v4 format */
export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
// ============================================================================
// Validators
// ============================================================================
/**
 * Validates email format according to RFC standards.
 * RFC 5321 length limit (254 characters) enforced.
 */
export function isValidEmail(email) {
    if (!email || email.length > EMAIL_MAX_LENGTH)
        return false;
    return EMAIL_REGEX.test(email);
}
/**
 * Validates URL format (http/https only).
 */
export function isValidUrl(url) {
    if (!url)
        return false;
    return URL_REGEX.test(url);
}
/**
 * Validates Ethereum wallet address format.
 * Format: 0x followed by 40 hexadecimal characters.
 */
export function isValidWalletAddress(address) {
    if (!address)
        return false;
    return WALLET_ADDRESS_REGEX.test(address);
}
/**
 * Validates that a string is not empty and meets minimum length.
 */
export function isValidNonEmptyString(value, minLength = 1) {
    return typeof value === 'string' && value.trim().length >= minLength;
}
/**
 * Validates UUID v4 format.
 */
export function isValidUuid(uuid) {
    if (!uuid)
        return false;
    return UUID_REGEX.test(uuid);
}
//# sourceMappingURL=validators.js.map